export { default } from 'rde-view-common/plugins/axios';
